import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from '@angular/material/snack-bar';

import { Router } from "@angular/router";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AlertService {
  constructor(
    private httpService: HttpClient,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  public sendMailPubIds() {
    const url = environment.api_base_url + "/tv/alert-pubid";

    return Observable.create((observer) => {
      this.httpService.get(url).subscribe(
        (response) => observer.next(response),
        (error) => observer.error(this.catchError(error))
      );
    });
  }

  private catchError(error: any, routeRedirect: string = null): void {
    this.snackBar.open(
      error.error.detail ? error.error.detail : "Une erreur est survenue",
      null,
      { duration: 2000, verticalPosition: "top" }
    );

    if (routeRedirect) {
      this.router.navigate([routeRedirect]);
    }

    return error;
  }
}
